import { useState } from 'react';
import { ModuleDataHandler } from '../helpers/handleReportCalc';
import TBodyRow from './TBodyRow';
import { useQuery } from '../../../../hooks/UseQuery';
interface IProps {
  moduleData: any;
  numberOfDay: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView, numberOfDay }: IProps) => {
  const department_name = useQuery('department_name');
  return (
    <tbody>
      {moduleData?.list?.length > 0 &&
        moduleData?.list?.map((item: any, index: number) => (
          <TBodyRow
            {...{
              moduleData,
              item,
              index,
              isView,
              numberOfDay,
            }}
          />
        ))}
    </tbody>
  );
};

export default TBody;
